var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.3332 2.99992C27.3332 1.53325 26.1332 0.333252 24.6665 0.333252H3.33317C1.8665 0.333252 0.666504 1.53325 0.666504 2.99992V18.9999C0.666504 20.4666 1.8665 21.6666 3.33317 21.6666H24.6665C26.1332 21.6666 27.3332 20.4666 27.3332 18.9999V2.99992ZM24.6665 2.99992L13.9998 9.66658L3.33317 2.99992H24.6665ZM24.6665 18.9999H3.33317V5.66658L13.9998 12.3333L24.6665 5.66658V18.9999Z","fill":"black","fillOpacity":"0.65"}));
}

Mail.defaultProps = {"width":"28","height":"22","viewBox":"0 0 28 22","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
